<template>
  <div>
    <p>Talk to {{member.name}} about:</p>
    <ul v-for="(value, opportunity) in member.opportunities">
      <li>{{opportunity}}</li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    member: {
      type: Object,
      required: true
    }
  },
}
</script>
